// API base URL
// Automatically switches between local dev API and production API based on hostname
let API_BASE = 'https://blivdesigns.com/backend/api';

if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  const isLocal =
    host === 'localhost' ||
    host === '127.0.0.1';

  if (isLocal) {
    API_BASE = 'http://localhost:8000/api';
  }
}

export default API_BASE;
